<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="padding-top:100px; padding-bottom:20px;">Acknowledgement</h1>
<p>In writing these stories over a period of years, I often asked a friend to read one or more – and comment. I am grateful for the time they took. But so many encouraged me to seek publication that I have yielded to temptation. The editorial staff of Austin Macauley, my publishers, has provided great support and assistance for my previous publications. And I thank them for having maintained the same for this book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7f64f2db